import { MBM_ACTIVE_STATUS, MbmProjectFilters } from '../types/mbm-project.types';

/**
 * Builds the Data Gateway filter for the list. The legacy endpoint matched customer and project
 * names case-insensitively and the customer by exact id; here one search box covers names and ids,
 * and "inactive" means any status other than `Active` (MBM sends free-form statuses).
 */
export const buildMbmProjectFilter = ({
  search,
  customerId,
  status,
}: MbmProjectFilters): Record<string, unknown> => {
  const conditions: Record<string, unknown>[] = [];

  const keyword = search?.trim();
  if (keyword) {
    // The gateway turns `$regex` into a literal `contains`, so the text is sent as typed.
    const regex = { $regex: keyword, $options: 'i' };
    conditions.push({
      $or: [
        { ProjectName: regex },
        { CustomerName: regex },
        { ProjectId: regex },
        { CustomerId: regex },
      ],
    });
  }

  if (customerId) conditions.push({ CustomerId: customerId });

  if (status === 'active') conditions.push({ Status: MBM_ACTIVE_STATUS });
  if (status === 'inactive') conditions.push({ Status: { $ne: MBM_ACTIVE_STATUS } });

  if (conditions.length === 0) return {};
  return conditions.length === 1 ? conditions[0] : { $and: conditions };
};
